import PropTypes from 'prop-types'
import { Button, HStack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Toast from '../Toast/Toast'

export default function DownloadButton({ label, icon, variant }) {
  if (variant === 'download') {
    return (
      <Button
        w="328px"
        h="96px"
        target="_blank"
        variant="white"
        download
        p={'25px 29px'}
      >
        <HStack>
          {icon && <FontAwesomeIcon icon={icon} />}
          <Text variant={'h5'}>{label}</Text>
        </HStack>
      </Button>
    )
  }
  return (
    <Toast variant="gray" as="button">
      <HStack h="100%" alignItems="center" justifyContent="center">
        {icon && <FontAwesomeIcon size="xl" icon={icon} />}
        {label && <Text variant="semibold">{label}</Text>}
      </HStack>
    </Toast>
  )
}

DownloadButton.propTypes = {
  icon: PropTypes.any,
  label: PropTypes.string,
  variant: PropTypes.string,
}
